 <div class="main">
    <div class="content"> 
      <div class="mb-3 mt-2  p-3 bg-white shadow rounded">
        <div class="row g-3 align-items-end">
           <div class="col-md-3">
            <label class="form-label fw-bold">Zone</label>
            <select id="ZONE_DESC" class="form-select">
              <option selected value="All">--All--</option>
              <option value="SOUTH 1">South 1</option>
              <option value="South 2">South 2</option>
              <option value="North">North</option> 
              <option value="East">East</option>
              <option value="West">West</option>
              <!-- <option value="CENTRAL">Central</option> -->
            </select>
          </div>

          <div class="col-md-3">
            <label class="form-label fw-bold">Region</label>
            <input id="region_code" type="text" class="form-control" />
          </div>

          <div class="col-md-3">
            <label class="form-label fw-bold">Area</label>
            <input id="area" type="text" class="form-control" />
          </div>

          <div class="col-md-3">
            <label class="form-label fw-bold">Dealer Parent</label>
            <input id="dealer_parent" type="text" class="form-control" />
          </div>
      
           <div class="col-md-3">
            <label class="form-label fw-bold">Dealer Code</label>
            <input id="Dealer_code" type="text" class="form-control" />
          </div>
      
           <div class="col-md-3">
            <label class="form-label fw-bold">Status</label>
            <select id="status" class="form-select">
              <option value="All" selected>--All--</option>
              <option value="Hot">Hot</option>
              <option value="Warm">Warm</option>
              <option value="Cold">Cold</option>
              <option value="Booked">Booked</option>
              <!-- <option value="O">Ordered</option> -->
              <option value="Retailed">Invoiced</option>
              <option value="Postponed">Postponed</option>
              <option value="Lost">Lost</option>
            </select>
          </div>

          <div class="col-md-3">
            <button class="header-btn" (click)="openDateRangePicker()">
              <img style="width: 12px;margin-left: 3px;margin-right: 8px;margin-bottom: 2px;" 
                [src]="bucketurl + '/images/calender.png'" alt="">Date Range
            </button>
            </div>
      
          <div class="col-md-3 d-flex align-items-center">
            <button class="btn custom-btn px-4" (click)="applyFilters()">Apply</button>
            <!-- <div class="rotate-icon-container ml-2" title="Clear Filter">
              <span class="rotate-icon"></span>
            </div> -->
          </div>
          
          
        </div>
      </div>
      
  
    </div>
  
  </div> 
<div #dashboardContainer style="width: 100%; height: 800px;"></div>


<ng-template #dateRangePicker>
  <h4 mat-dialog-title>
    Date Range
    <img class="close-button" src="/assets/images/close.png" (click)="closeDialog()" alt="">
  </h4>
  <mat-dialog-content class="date-range-picker">
    <div class="date-range-picker__content">
      <div class="date-range-picker__sidebar">
        <button class="date-btn" mat-button class="sidebar-button" [class.selected]="selectedButton === 'today'"
          (click)="selectToday()">Today</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'last7'"
          (click)="selectLast7Days()">Last 7 days</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'last15'"
          (click)="selectLast15Days()">Last 15 days</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'thisMonth'"
          (click)="selectThisMonth()">This Month</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'custom'"
          (click)="selectCustom()">Custom</button>
      </div>
      <div class="date-range-picker__main" [ngClass]="{ 'isDateCustom': selectedButton != 'custom'}">
        <mat-calendar (selectedChange)="selectedChange($event)" [maxDate]="today" [selected]="dateRange"
          #startCalendar></mat-calendar>
      </div>
    </div>

    <div mat-dialog-actions class="d-flex justify-content-between align-items-center">
      <div class="date-display">
        <span class="date-label" *ngIf="startDate">From:</span> <span class="date-value">{{startDate |
          date:'dd-MMM-yyyy'}}</span>
        <span class="date-label ml-2" *ngIf="endDate">To:</span> <span class="date-value">{{endDate |
          date:'dd-MMM-yyyy'}}</span>
      </div>
      <div>
        <button #cancelButton class="btn white-btn mr-2" type="button" (click)="closeDialog()">Cancel</button>
        <button class="btn blue-btn" type="submit" (click)="applyDateRange()">Apply</button>
      </div>
    </div>
  </mat-dialog-content>
</ng-template>